import type { AssessmentSchema } from './types';

const registry = new Map<string, AssessmentSchema>();

export function registerSchema(schema: AssessmentSchema): void {
  if (registry.has(schema.id)) {
    throw new Error(`Duplicate schema id: ${schema.id}`);
  }
  registry.set(schema.id, schema);
}

export function getSchema(id: string): AssessmentSchema | undefined {
  return registry.get(id);
}

export function getSchemaBySlug(slug: string): AssessmentSchema | undefined {
  for (const s of registry.values()) {
    if (s.slug === slug) return s;
  }
  return undefined;
}

export function listSchemas(): AssessmentSchema[] {
  return Array.from(registry.values());
}

export function _resetRegistryForTests(): void {
  registry.clear();
}
